// ======================================================================
// File Name       : CourseTreeContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector, isInvalid, getFormValues } from 'redux-form';
import { Form, FormControl, Col, InputGroup, Button, Row } from 'react-bootstrap';
import moment from 'moment';
import TreeViewDropdowmControl from '../../components/TreeWithDropdownControl';
import * as containerAction from '../../actions/ContainerAction';
import { openModal } from '../../actions/ModalAction';
import ICON_COURSE from '../../images/tree/course-icon.png';
import ICON_COURSE_EXTERNAL from '../../images/tree/course-icon-external.png';
import ICON_BOX from '../../images/tree/box-icon.png';
import ICON_DRILL from '../../images/tree/drill-icon.png';
import ICON_VIDEO from '../../images/tree/video-icon.png';
import ICON_DOCUMENT from '../../images/tree/document-24.png';
import ICON_LINK from '../../images/tree/link.png';
import { STRUCTURE_TYPE, MODE, WAIT_RENDER_TIME } from '../../constants';
import * as Functions from '../../constants/FunctionConstants';
import * as Path from '../../constants/PathConstants';
import * as ModalIds from '../../constants/ModalIds';
import { canAccess } from '../../utils/AuthedUtils';
import { showExportCSVSuccessMessage, showSuccessMessage } from '../../utils/index';
import { CONTENT_TYPE, DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import * as courseActions from '../../actions/CourseAction';
import { BULK_EXPORT, MSG_EXPORT_CSV_SUCCESS, I_RESET_COURSE_CONDITION_SUCCESS } from '../../constants/MessageTemplate';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import CustomButton from '../../components/button/CustomButton';
import * as actionTypeContainer from '../../constants/actionTypes/container';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../../components/button/CustomLink';

// Node menu, position of menu item based on position its function in array
const COURSE_FUNCTION = [
  Functions.COURSE_DETAIL,
  Functions.BOX_REGSITER,
  Functions.COURSE_SORT,
  Functions.COURSE_RESET_CONDITION,
  Functions.COURSE_DELETE,
];
const CONTENT_FUNCTION = [
  Functions.CONTENT_LINKING_SORT,
  Functions.CONTENT_LINKING_DETAIL,
  Functions.CONTENT_LINKING_DELETE,
];
const BOX_FUNCTION = [
  Functions.CONTENT_LINKING_REGISTER,
  Functions.BOX_REGSITER,
  Functions.BOX_SORT,
  Functions.BOX_DETAIL,
  Functions.BOX_DELETE,
];

const ONLY_MENU_DETAIL = [
  Functions.COURSE_DETAIL,
  Functions.CONTENT_LINKING_DETAIL,
  Functions.BOX_DETAIL,
];

const initCourseTree = false;

class CourseTreeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      structureSecernId: '',
      structureTypeName: '',
      isSearchOnCondition: true,
    };

    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.searchCondition = this.searchCondition.bind(this);
    this.handleAddCourseBtnClick = this.handleAddCourseBtnClick.bind(this);
    this.handleTreeDetailBtnClick = this.handleTreeDetailBtnClick.bind(this);
    this.handleTreeAddBtnClick = this.handleTreeAddBtnClick.bind(this);
    this.handleLinkingBtnClick = this.handleLinkingBtnClick.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.getSearchResult = this.getSearchResult.bind(this);
    this.resetCourseCondition = this.resetCourseCondition.bind(this);
    this.hideLoading = this.hideLoading.bind(this);
  }

  /*
   * Condition checking callback of tree search
   * If the function returns a truthy value the node will be considered a match
   */
  searchCondition(filterText, node) {
    const { data } = node;
    const { callbackData } = data;
    const {
      structureName,
      structureType,
      publicStatus,
      publicPeriodFrom,
      publicPeriodTo,
      contentType } = callbackData;
    const filterData = this.props.courseSearchForm;

    let testResult = false;
    testResult = filterData.name ? structureName.indexOf(filterData.name) > -1 : true;
    if (!isNaN(parseInt(filterData.contentType, 10))) {
      const cond2 = filterData.contentType === contentType;
      testResult = testResult && cond2;
    }
    if (!isNaN(parseInt(filterData.publicStatus, 10))) {
      const cond3 = filterData.publicStatus === publicStatus;
      testResult = testResult && cond3;
    }
    if (filterData.publicPeriodFrom) {
      if (publicPeriodTo){
        const cond4 = moment(publicPeriodTo).isSameOrAfter(filterData.publicPeriodFrom);
        testResult = testResult && cond4;
      } else {
        testResult = false;
      }
    }
    if (filterData.publicPeriodTo) {
      if (publicPeriodFrom){
        const cond5 = moment(publicPeriodFrom).isSameOrBefore(filterData.publicPeriodTo);
        testResult = testResult && cond5;
      } else {
        testResult = false;
      }
    }

    return testResult;
  }

  handleSearchBtn() {
    let isSearchOnCondition = false;

    const { courseSearchForm, invalid } = this.props;
    if (!this.treeInstance || invalid) {
      return;
    }
    this.props.dispatch(showLoading()).then(() => {
      const self = this;
      if (!courseSearchForm) {
        // reset search
        this.getSearchResult(false, []);
        setTimeout(() => { self.treeInstance.clearSearch(); }, WAIT_RENDER_TIME);
        return;
      }

      const courseSearchCondition = Object.keys(courseSearchForm).reduce((acc, cur) => {
        if (cur && courseSearchForm[cur] !== null &&
          courseSearchForm[cur] !== undefined &&
          courseSearchForm[cur] !== '') {
          acc.push(cur);
        }
        return acc;
      }, []);
      if (courseSearchCondition && courseSearchCondition.length) {
        isSearchOnCondition = true;
      }
      if (isSearchOnCondition) {
        setTimeout(() => { self.treeInstance.search(courseSearchCondition); }, WAIT_RENDER_TIME);
      } else {
        // reset search
        this.getSearchResult(false, []);
        setTimeout(() => { self.treeInstance.clearSearch(); }, WAIT_RENDER_TIME);
      }
    });
  }

  handleAddCourseBtnClick() {
    const { dispatch } = this.props;
    dispatch(courseActions.resetData());
    dispatch(courseActions.changeEditType(MODE.NEW_MODE));
    dispatch(containerAction.openCourseRegisterDialog());
  }

  handleTreeDetailBtnClick(data, nodeData, node) {
    const { dispatch } = this.props;
    // sprint_20230522_tma START
    this.props.dispatch({
      type: actionTypeContainer.REMOVED_DATA_WITH_SELECTED_ITEM_LIST,
    });
    // sprint_20230522_tma END
    dispatch(containerAction.openDetailDialog(data.structureSecernId, node));
  }

  handleTreeAddBtnClick(data) {
    const { dispatch } = this.props;
    // sprint_20230522_tma START
    this.props.dispatch({
      type: actionTypeContainer.REMOVED_DATA_WITH_SELECTED_ITEM_LIST,
    });
    // sprint_20230522_tma END
    dispatch(containerAction.openRegisterDialog(data.structureSecernId));
  }

  handleLinkingBtnClick(data) {
    const { dispatch } = this.props;
    // sprint_20230522_tma START
    this.props.dispatch({
      type: actionTypeContainer.REMOVED_DATA_WITH_SELECTED_ITEM_LIST,
    });
    // sprint_20230522_tma END
    dispatch(containerAction.openContentLinkingRegisterDialog(data.structureSecernId));
  }

  resetCourseCondition(data) {
    const { dispatch } = this.props;
    // call API 開始・完了条件再判定API
    if (data && data.structureSecernId) {
      dispatch(courseActions.resetCourseCondition(data.structureSecernId)).then(() => {
        showSuccessMessage(I_RESET_COURSE_CONDITION_SUCCESS);
      });
    }
  }

  handleSort(data) {
    const { dispatch } = this.props;
    dispatch(containerAction.openSortModal(data.structureSecernId));
  }

  /**
   * Create node
   * Based on "structure" in param, create corresponding JStree's node
   * - Node's text will show structureName
   * - Icon and menu is determined by structureType
   * - Functions are in menu checked whether user can access
   * - OnClick: passing "structure" as "callbackData" to callback function
   * @param {Object} param
   */
  createNode({ structure }) {
    const {
      structureType,
      structureSecernId,
      structureName,
      contentType,
      hasSubStructures,
      dataAffiliationType } = structure;
    /**
     * Determine icon and functions of node
     */
    let icon = false;
    let menuFunctions = [];
    switch (structureType) {
      case STRUCTURE_TYPE.COURSE:
        icon = dataAffiliationType === DATA_AFFIILIATION_TYPE.EXTERNAL ?
        ICON_COURSE_EXTERNAL : ICON_COURSE;
        menuFunctions = [...COURSE_FUNCTION];
        break;
      case STRUCTURE_TYPE.BOX:
        menuFunctions = [...BOX_FUNCTION];
        icon = ICON_BOX;
        break;
      case STRUCTURE_TYPE.ITEM:
        menuFunctions = [...CONTENT_FUNCTION];
        switch (contentType) {
          case CONTENT_TYPE.VIDEO:
            icon = ICON_VIDEO;
            break;
          case CONTENT_TYPE.DRILL:
            icon = ICON_DRILL;
            break;
          case CONTENT_TYPE.DOCUMENT:
            icon = ICON_DOCUMENT;
            break;
          case CONTENT_TYPE.LINK:
            icon = ICON_LINK;
            break;
          default:
            break;
        }
        break;
      default:
        icon = false;
        menuFunctions = [];
    }
    let menu = [];

    // check access menu with course group relations
    const { indirectOnCourseRelation, isAdminHasCourseRelation } = this.props.container;

    /*
     * Build menu corresponding to structure type
     * Check function in userFunctions whether user can access
     */
    menu = menuFunctions.reduce((acc, functionName) => {
      if (canAccess(functionName)) {
        switch (functionName) {
          // Menu item of COURSE
          // Menu item 詳細表示・ユーザー紐付け
          case Functions.COURSE_DETAIL:
            acc.push(createDetailMenu({ structureSecernId }, '詳細表示・ユーザー紐付け', this.handleTreeDetailBtnClick));
            break;
          // Menu item of BOX
          // Menu item セクション新規作成
          case Functions.BOX_REGSITER:
            if (dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
              acc.push(createBoxRegisterMenu({ structureSecernId }, this.handleTreeAddBtnClick));
            }
            break;
          // Menu item of COURSE
          // Menu item 学習状況の更新 - createResetConditionMenu()
          case Functions.COURSE_RESET_CONDITION:
            if (canAccess(Functions.COURSE_EDIT)) { // Step9.4.0
              acc.push(createResetConditionMenu({ structureSecernId }, this.resetCourseCondition));
            }
            break;
          // Menu item of BOX
          // Menu item コンテンツ紐付け
          case Functions.CONTENT_LINKING_REGISTER:
            if (dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
              acc.push(createContentLinkingMenu({ structureSecernId }, this.handleLinkingBtnClick));
            }
            break;
          // Menu item of CONTENT and BOX
          // Menu item 詳細表示 - createDetailMenu()
          case Functions.CONTENT_LINKING_DETAIL:
          case Functions.BOX_DETAIL:
            acc.push(createDetailMenu({ structureSecernId }, '詳細表示', this.handleTreeDetailBtnClick));
            break;
          // Menu item of COURSE, BOX, CONTENT
          // Menu item 並び準変更 - createSortMenu()
          case Functions.COURSE_SORT:
            if( !isAdminHasCourseRelation ){
              acc.push(createSortMenu({ structureSecernId }, this.handleSort));
            }
            break;
          case Functions.BOX_SORT:
          case Functions.CONTENT_LINKING_SORT:
            if (dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
              acc.push(createSortMenu({ structureSecernId }, this.handleSort));
            }
            break;
          // Menu item of COURSE, BOX, CONTENT
          // Menu item 削除
          case Functions.COURSE_DELETE:
            // #7492 START
            if (!hasSubStructures && dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL && !isAdminHasCourseRelation) {
              acc.push(createDeleteMenu({ structureSecernId }, this.props.handleDelete));
            }
            break;
            // #7492 END
          case Functions.BOX_DELETE:
          case Functions.CONTENT_LINKING_DELETE:
            // #7308 START
            if (!hasSubStructures && dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
            // #7308 END
              acc.push(createDeleteMenu({ structureSecernId }, this.props.handleDelete));
            }
            break;
          default:
        }
      }

      return acc;
    }, menu);

    /**
     * JSTree node's data
     */
    return {
      id: structureSecernId,
      text: structureName,
      icon,
      data: {
        menu,
        callbackData: structure,
      },
      children: [],
    };
  }

  /**
   * Build course tree
   * This function will be started from list of courseSecernId
   * By courseSecernId find and build entire box, item nodes below
   * On current development, structureType=[2:item] is a leaf node
   * so just only perform searching child node on type=[1:box]
   */
  createCourseTree() {
    const { structures } = this.props.container;

    /**
     * Sort list by displayOrder and structureSecernId
     * @param {Array} listOfNode
     */
    const sortByDisplayOrderAndStructureSecernId = (listOfNode) => {
      const sortedList = [...listOfNode];
      sortedList.sort((curNode, nextNode) => {
        const curNodeData = curNode.data.callbackData;
        const nextNodeData = nextNode.data.callbackData;
        if (curNodeData.structureType === STRUCTURE_TYPE.BOX &&
          nextNodeData.structureType === STRUCTURE_TYPE.ITEM) {
          return -1;
        }
        if (curNodeData.structureType === STRUCTURE_TYPE.ITEM &&
          nextNodeData.structureType === STRUCTURE_TYPE.BOX) {
          return 1;
        }
        if (curNodeData.displayOrder || nextNodeData.displayOrder) {
          if (curNodeData.displayOrder < nextNodeData.displayOrder) {
            return -1;
          }
          if (curNodeData.displayOrder > nextNodeData.displayOrder) {
            return 1;
          }
        }
        return curNodeData.structureSecernId.localeCompare(nextNode.structureSecernId);
      });
      return sortedList;
    };

    let tree = [], 
        nodeMapper = {}, needtoSortNodes = {};

    for (var id in structures.bySecernId) {
      const node = structures.bySecernId[id];
      const arrElem = this.createNode({
        structure: node,
      });

      arrElem.parentCourseSecernId = node.parentCourseSecernId;
      arrElem.parentBoxSecernId = node.parentBoxSecernId;
      arrElem.children = [];
      nodeMapper[id] = arrElem;

    }

    for(var key in nodeMapper){
      const node = nodeMapper[key];
      if (node.parentCourseSecernId) {
        nodeMapper[node.parentCourseSecernId].children.push(node);
        needtoSortNodes[node.parentCourseSecernId] = nodeMapper[node.parentCourseSecernId];
      } else if (node.parentBoxSecernId) {
        nodeMapper[node.parentBoxSecernId].children.push(node);
        needtoSortNodes[node.parentBoxSecernId] =  nodeMapper[node.parentBoxSecernId];
      }
      else {
        tree.push(node);
      }
    }

    //sort course
    tree = sortByDisplayOrderAndStructureSecernId(tree);

    //sort box, item
    for(var key in needtoSortNodes){
      const node = needtoSortNodes[key];
      if (node.children && node.children.length > 0) {
        node.children = sortByDisplayOrderAndStructureSecernId(node.children);
      }
    }

    //structures
    return tree;

  }

  getSearchResult(isSearchCondition, resultList) {
    if (this.props.updateSearchResult) {
      this.props.updateSearchResult(isSearchCondition, resultList);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // check tree is init or not to prevent render many times
    let isInitiated = false;
    if (nextProps.isInitiated) {
      if (!this.initCourseTree) {
        isInitiated = nextProps.isInitiated;
        this.initCourseTree = nextProps.isInitiated;
      }
    } else {
      this.initCourseTree = nextProps.isInitiated;
    }
    const shouldNotUpdate =
    nextProps.container.structures === this.props.container.structures &&
    nextProps.container.structures.bySecernId === this.props.container.structures.bySecernId &&
    nextProps.container.structures.courseSecernIds === this.props.container.structures.courseSecernIds;
    return isInitiated || (nextProps.isInitiated && !shouldNotUpdate);
  }

  hideLoading() {
    this.props.dispatch(hideLoading());
  }

  render() {
    // Build course nodes
    let nodes = [];
    if (this.initCourseTree) {
      nodes = this.createCourseTree();
    }
    return (
      <div>
        <ActionForm
          onClickSearchBtn={this.handleSearchBtn}
          handleAddCourseBtnClick={this.handleAddCourseBtnClick}
          handleExportBtn={this.props.handleExportBtn}
        />
        {this.initCourseTree ?
          <TreeViewDropdowmControl
            data={nodes}
            ref={(instance) => {
              this.treeInstance = instance;
            }}
            searchOnCondition={(filterData, data) => this.searchCondition(filterData, data)}
            getSearchResult={this.getSearchResult.bind(this)}
            isSearchOnCondition={this.state.isSearchOnCondition}
            hideLoading={this.hideLoading}
          /> :
          <div className="card padding-10">
            <div className="loading tree-loading"></div>
            <div style={{ lineHeight: '20px' }}>Please wait ...</div>
          </div>
        }
      </div>
    );
  }
}

CourseTreeContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  container: PropTypes.shape().isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { container, authed } = state;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  return {
    container,
    courseSearchForm: getFormValues('courseSearchForm')(state),
    invalid: isInvalid('courseSearchForm')(state),
    displayUserType: userInfo ? userInfo.displayUserType : null,
    isInitiated: container.isInitiated,
  };
};

export default connect(mapStateToProps, null, null, { withRef: true })(CourseTreeContainer);

const ActionForm = ({ onClickSearchBtn, handleAddCourseBtnClick, handleExportBtn }) =>
  (<Form className='form-horizontal' onSubmit={(e) => { e.preventDefault(); }}>
    <Row className="margin-bottom-15">
      <Form.Group className="margin-top-20 text-center">
        <Col sm={12}>
          <CustomButton
            btnStyle="btn btn-primary btn-96"
            handleClick={onClickSearchBtn}
            text="検索"
            iconClass="bi bi-search"
          />
        </Col>
      </Form.Group>
      <Form.Group>
        {/*sprint_20230619 START */}
        <Col sm={12} className="padding-left-right-clear">
        <Col sm={9} className="inline-flex">
          {canAccess(Functions.COURSE_EDIT) &&
            <>
              <CustomLink
                className="margin-right-7 btn-register float-start btn-96 margin-right-10"
                onClick={handleAddCourseBtnClick}
                text="コース追加"
                icon={ICON.REGIST}
              />
              <CustomLink
                className="margin-right-7 btn-csv-import"
                to={Path.COURSE_IMPORT}
                text="CSV一括投入"
                icon={ICON.IMPORT}
              />
            </>
          }
        </Col>
        <Col sm={3}>
          <CustomButton
            btnStyle="btn btn-export-csv btn-96 float-end"
            handleClick={handleExportBtn}
            text="一括出力"
            iconClass="bi bi-download"
          />
        </Col>
      </Col>
        {/*sprint_20230619 START */}
      </Form.Group>
    </Row>
  </Form>);

//
// Menu creators
//
function createDetailMenu(data = {}, menuTitle, onClick = () => { }) {
  return {
    data,
    label: menuTitle,
    text: menuTitle,
    icon: 'bi bi-info-circle',
    onClick,
  };
}

function createBoxRegisterMenu(data = {}, onClick = () => { }) {
  return {
    data,
    label: 'セクション新規登録',
    text: 'セクション新規登録',
    icon: 'bi bi-plus-lg',
    onClick,
  };
}

function createDeleteMenu(data = {}, onClick = () => { }) {
  return {
    data,
    label: '削除',
    text: '削除',
    icon: 'bi bi-x-circle',
    onClick,
  };
}

function createContentLinkingMenu(data = {}, onClick = () => { }) {
  return {
    data,
    label: 'コンテンツ紐付け',
    text: 'コンテンツ紐付け',
    icon: 'bi bi-link-45deg',
    onClick,
  };
}

function createSortMenu(data = {}, onClick = () => { }) {
  return {
    data,
    label: '並び順変更',
    text: '並び順変更',
    icon: 'bi bi-justify',
    onClick,
  };
}

function createResetConditionMenu(data = {}, onClick = () => { }) {
  return {
    data,
    label: '学習状況の更新',
    text: '学習状況の更新',
    icon: 'bi bi-justify',
    onClick,
  };
}
